import { render, staticRenderFns } from "./EventFilterDefaultLayout.vue?vue&type=template&id=6fb8af96"
import script from "./EventFilterDefaultLayout.vue?vue&type=script&lang=js"
export * from "./EventFilterDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports